import { Pipe, PipeTransform } from "@angular/core";
import { environment } from '@env/environment';

@Pipe({
    name: 'imagePathFormat'
})
export class ImagePathFormatter implements PipeTransform {
    transform(value: any) {
      return value ? environment.resourcesUrl + value.toString().replace(new RegExp('/', 'g'), '%2F') : null;
    }
}
